module.exports = __webpack_public_path__ + "static/media/Kindred_0.728455cf.jpg";